export const SLIDER_IMAGES = [
  '/images/slider/bb_1.png',
  '/images/slider/bb_4.png',
  '/images/slider/bb_7.png',
  '/images/slider/bb_2.png',
  '/images/slider/bb_5.png',
  '/images/slider/bb_3.png',
  '/images/slider/bb_6.png',
] as const
